import { AngularEditorConfig } from '@kolkov/angular-editor';

export class GlobalConstants {
  public static readonly TaskStatuses = [
    { value: 0, label: 'AllStatuses', colorClass: 'badge bg-secondary-soft' },
    { value: 1, label: 'New', colorClass: 'badge bg-secondary-soft' },

    {
      value: 10,
      label: 'DeveloperStarted',
      colorClass: 'badge bg-primary-soft',
    },
    {
      value: 20,
      label: 'DeveloperPaused',
      colorClass: 'badge bg-primary-soft',
    },
    {
      value: 30,
      label: 'DeveloperResumed',
      colorClass: 'badge bg-primary-soft',
    },
    {
      value: 40,
      label: 'DeveloperCompleted',
      colorClass: 'badge bg-primary-soft',
    },

    { value: 50, label: 'TesterStarted', colorClass: 'badge bg-warning-soft' },
    { value: 60, label: 'TesterPaused', colorClass: 'badge bg-warning-soft' },
    { value: 70, label: 'TesterResumed', colorClass: 'badge bg-warning-soft' },
    {
      value: 80,
      label: 'TesterCompleted',
      colorClass: 'badge bg-warning-soft',
    },

    { value: 90, label: 'Rejected', colorClass: 'badge bg-danger-soft' },
    { value: 100, label: 'Approved', colorClass: 'badge bg-success-soft' },
  ];

  public static readonly TaskStatusesFilter = [
    { value: '', label: 'All Statuses' },
    { value: 'new', label: 'New' },
    { value: 'started', label: 'Started' },
    { value: 'paused', label: 'Paused' },
    { value: 'completed', label: 'Completed' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
  ];

  public static readonly StoryStatuses = [
    { value: 0, label: 'All Statuses', colorClass: 'badge bg-secondary-soft' },
    { value: 10, label: 'New', colorClass: 'badge bg-secondary-soft' },
    { value: 20, label: 'Pending', colorClass: 'badge bg-warning-soft' },
    { value: 30, label: 'Approved', colorClass: 'badge bg-success-soft' },
    { value: 40, label: 'Rejected', colorClass: 'badge bg-danger-soft' },
  ];

  public static readonly QuoteStatuses = [
    { value: 0, label: 'Draft', colorClass: 'text-white badge bg-secondary' },
    { value: 10, label: 'New', colorClass: 'text-white badge bg-primary' },
    { value: 20, label: 'Pending', colorClass: 'text-white badge bg-warning' },
    { value: 30, label: 'Rejected', colorClass: 'text-white badge bg-danger' },
    { value: 40, label: 'Approved', colorClass: 'text-white badge bg-info' },
    {
      value: 50,
      label: 'ReadyToStart',
      colorClass: 'text-white badge bg-info',
    },
    {
      value: 60,
      label: 'WaitingStartTimeInput',
      colorClass: 'text-white badge bg-warning',
    },
    {
      value: 70,
      label: 'WaitingStartTimeExecution',
      colorClass: 'text-white badge bg-info',
    },
    {
      value: 80,
      label: 'InProgress',
      colorClass: 'text-white badge bg-success',
    },
  ];

  public static readonly ContractStatuses = [
    { value: 0, label: 'All Statuses', colorClass: 'badge bg-secondary-soft' },
    { value: 10, label: 'New', colorClass: 'badge bg-secondary-soft' },
    { value: 20, label: 'Pending', colorClass: 'badge bg-warning-soft' },
    { value: 30, label: 'Approved', colorClass: 'badge bg-success-soft' },
    { value: 40, label: 'Rejected', colorClass: 'badge bg-danger-soft' },
  ];

  public static readonly TimeOptions = [
    { value: '0.1667', label: '10 minutes' },
    { value: '0.25', label: '15 minutes' },
    { value: '0.5', label: '30 minutes' },
    { value: '0.75', label: '45 minutes' },
    { value: '1', label: '1 hour' },
    { value: '2', label: '2 hours' },
    { value: '4', label: '4 hours' },
    { value: '6', label: '6 hours' },
    { value: '8', label: '1 work day' },
    { value: '16', label: '2 work days' },
    { value: '24', label: '3 work days' },
    { value: '32', label: '4 work days' },
    { value: '40', label: '5 work days' },
    { value: '80', label: '10 work days' },
    { value: '120', label: '15 work days' },
    { value: '160', label: '20 work days' },
    { value: '240', label: '30 work days' },
  ];

  public static readonly Months = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
  ];

  public static readonly PriorityLevels = [
    { value: 1, label: 'Urgent', colorClass: 'badge bg-danger-soft' },
    { value: 2, label: 'VeryHigh', colorClass: 'badge bg-danger-soft' },
    { value: 3, label: 'High', colorClass: 'badge bg-warning-soft' },
    { value: 4, label: 'Medium', colorClass: 'badge bg-success-soft' },
    { value: 5, label: 'Low', colorClass: 'badge bg-secondary-soft' },
  ];

  public static readonly DifficultyLevels = [
    { value: 0, label: 'None', colorClass: 'badge bg-secondary-soft' },
    { value: 1, label: 'Easy', colorClass: 'badge bg-success-soft' },
    { value: 2, label: 'Medium', colorClass: 'badge bg-warning-soft' },
    { value: 3, label: 'Hard', colorClass: 'badge bg-danger-soft' },
  ];

  public static readonly StoryTypes = [
    { value: 1, label: 'Feature', colorClass: 'badge bg-primary-soft' },
    { value: 2, label: 'Bug', colorClass: 'badge bg-danger-soft' },
    { value: 3, label: 'Improvement', colorClass: 'badge bg-success-soft' },
    { value: 4, label: 'Inquiry', colorClass: 'badge bg-info-soft' },
    { value: 5, label: 'Research', colorClass: 'badge bg-warning-soft' },
    { value: 6, label: 'Documentation', colorClass: 'badge bg-secondary-soft' },
    { value: 7, label: 'TechnicalDebt', colorClass: 'badge bg-dark-soft' },
    { value: 8, label: 'Testing', colorClass: 'badge bg-warning-soft' },
    { value: 9, label: 'Integration', colorClass: 'badge bg-info-soft' },
    { value: 10, label: 'Optimization', colorClass: 'badge bg-success-soft' },
    { value: 11, label: 'Design', colorClass: 'badge bg-pink-soft' },
    { value: 12, label: 'Security', colorClass: 'badge bg-danger-soft' },
    { value: 13, label: 'Migration', colorClass: 'badge bg-teal-soft' },
    { value: 14, label: 'Configuration', colorClass: 'badge bg-indigo-soft' },
    { value: 15, label: 'Support', colorClass: 'badge bg-secondary-soft' },
  ];

  public static readonly EditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter content here...',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'link', 'unlink'],
      ['customClasses', 'strikeThrough', 'subscript', 'superscript'],
    ],
  };
}
